import renderjson from "renderjson"

// Configure renderjson defaults
renderjson.set_show_to_level("all")
renderjson.set_icons("▶", "▼")

// Auto-render JSON for elements with data-render-json attribute
// Usage: <pre data-render-json class="renderjson-container">{"key": "value"}</pre>
function renderJsonElements() {
  document.querySelectorAll("[data-render-json]").forEach((el) => {
    try {
      const jsonData = JSON.parse(el.textContent)
      const container = document.createElement("div")
      container.className = el.className || "renderjson-container"
      container.appendChild(renderjson(jsonData))
      el.replaceWith(container)
    } catch (e) {
      console.error("Failed to parse JSON:", e)
    }
  })
}

// Run on page load and Turbo navigation
document.addEventListener("DOMContentLoaded", renderJsonElements)
document.addEventListener("turbo:load", renderJsonElements)
